import { Directive, input, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[tooltip]',
  standalone: true,
  hostDirectives: [
    {
      directive: MatTooltip,
      inputs: ['matTooltipDisabled: tooltipDisabled']
    }
  ]
})
export class TooltipDirective implements OnInit {
  private _matTooltip = inject(MatTooltip);

  tooltip = input.required<string>();
  tooltipPosition = input<
    'above' | 'below' | 'left' | 'right' | 'before' | 'after'
  >('above');

  ngOnInit(): void {
    this._matTooltip.message = this.tooltip();
    this._matTooltip.position = this.tooltipPosition();
  }
}
